export default "__VITE_ASSET__CR5oZ_iL__"